import { CONTENT_TYPE, TYPE_QUESTIONS } from '@educaplay/core'
import { checkTypeAnswer } from './functions'
import { GAMETYPES, GAME_MODES } from './constants';

export function getQuestionsWithScreens({ data, resources }) {

    const gameType = data.FORMA_JUEGO;
    let lastScreenIndexUsed = 0;
    const getFilteredQuestions = () => {
        let infoScreen = [];
        let playScreen = [];

        const filteredQuestions =  data.PUNTOS_MAPA.map((point, index) => 
            {return {
                ...point,
                originId: index,
            }
        })
        .filter(point => (((point.ENUNCIADO && point.ENUNCIADO !== "") || (point.MULTIMEDIA && point.MULTIMEDIA !== "")) && point.x !== "" && point.y !== ""));
        filteredQuestions.forEach((question, index) => {
            const newQuestion = {
                ...question,
                mapImage: `${resources}${data.IMAGEN}`,
            };

            if (gameType === GAMETYPES.BOTH || gameType === GAMETYPES.DEMO) {
                infoScreen.push({
                    ...newQuestion,
                    id: `${lastScreenIndexUsed}-${index}`,
                    screenId: `${lastScreenIndexUsed}`,
                    answers: [{
                        answer: question.ENUNCIADO,
                        source: question.MULTIMEDIA ? `${resources}${question.MULTIMEDIA}` : null,
                        type: question.MULTIMEDIA_TIPO ?? null,
                        id: `${lastScreenIndexUsed}-${index}`,
                    }],
                    mode: GAME_MODES.EXPLORE
                });
            }

            if (gameType === GAMETYPES.GAME) {
                playScreen.push({
                    ...newQuestion,
                    id: `${lastScreenIndexUsed}-${index}`,
                    screenId: `${lastScreenIndexUsed}`,
                    answers: [{
                        answer: question.ENUNCIADO,
                        source: question.MULTIMEDIA ? `${resources}${question.MULTIMEDIA}` : null,
                        type: question.MULTIMEDIA_TIPO ?? null,
                        id: `${lastScreenIndexUsed}-${index}`,
                    }],
                    mode: GAME_MODES.PLAY
                });
            }

            if (gameType === GAMETYPES.BOTH) {
                playScreen.push({
                    ...newQuestion,
                    id: `${lastScreenIndexUsed + 1}-${index}`,
                    screenId: `${lastScreenIndexUsed + 1}`,
                    answers: [{
                        answer: question.ENUNCIADO,
                        source: question.MULTIMEDIA ? `${resources}${question.MULTIMEDIA}` : null,
                        type: question.MULTIMEDIA_TIPO ?? null,
                        id: `${lastScreenIndexUsed + 1}-${index}`,
                    }],
                    mode: GAME_MODES.PLAY
                });
            }
        });
        lastScreenIndexUsed = gameType === GAMETYPES.BOTH ? lastScreenIndexUsed + 2 : lastScreenIndexUsed + 1;

        if(data.RESPUESTA_ESCRITA === "si") playScreen = playScreen.filter(question => question.ENUNCIADO !== "");

        const questionsToAdd = (gameType === GAMETYPES.BOTH) ? [...infoScreen, ...playScreen] : (gameType === GAMETYPES.GAME) ? playScreen : infoScreen;
        return questionsToAdd;
    };
    const filteredQuestions = getFilteredQuestions();


    const isCaseSensitive = data.SENSIBLE_MAYUSCULAS_ACENTOS === 'si';


    const questionTimeNumber = Number(data.TIEMPO)
    const questionTime = Number.isNaN(questionTimeNumber) ? 0 : questionTimeNumber;

    const points = 100 / filteredQuestions.filter((question) => question.mode === GAME_MODES.PLAY).length;

    const questions = [];

    filteredQuestions.map((question) => {

        const questionType = (data.RESPUESTA_ESCRITA === "si") ? TYPE_QUESTIONS.Text : TYPE_QUESTIONS.Selection;

        const correctAnswers = [question.DESCRIPCION ?? "-"];
        const correctAnswersSelection = [question.id];
        const correctAnswersText = [question.ENUNCIADO.trim()];

        const checkAnswer = (objAnswer) => {

            return checkTypeAnswer({
                sortedAnswered: objAnswer.answer,
                questionType: objAnswer.type,
                isCaseSensitive,
                correctAnswersText,
                correctAnswersSelection
            });
        }

        const calculatePoints = (_userAnswer, { tries = [] }) => {

            if (tries.length === 0) return points;
            if (tries.length === 1) return points / 2;
            if (tries.length === 2) return points / 4;
            return 0;
        }


        const commonAssets = {
            x: question.X,
            y: question.Y,
            checkAnswer,
            calculatePoints,
            correctAnswers,
            explanation: question.EXPLICACION ?? null,
            description: question.DESCRIPCION ?? null,
            title: question.ENUNCIADO ?? null,
            answer: null,
            points,
            time: questionTime,
            id: question.id,
            screenId: question.screenId,
            mapImage: question.mapImage,
            additionalInfo: true,
            answers: question.answers,
            type: questionType,
            mode: question.mode,
            media: question.MULTIMEDIA ? {
                type: question.MULTIMEDIA_TIPO ?? null,
                src: question.MULTIMEDIA ? `${resources}${question.MULTIMEDIA}` : null,
            } : null,
            text: question.ENUNCIADO,
            feedback: question.EXPLICACION,
            originId: question.originId,
        }

        const hasBank = (questionType === TYPE_QUESTIONS.Selection && (question.ENUNCIADO || question.MULTIMEDIA))
            || (questionType === TYPE_QUESTIONS.Text && (question.DESCRIPCION || question.MULTIMEDIA));


        if (question.mode === GAME_MODES.EXPLORE) {
            questions.push({
                ...commonAssets,
                type: TYPE_QUESTIONS.Selection,
                bank: null
            })
        }

        if (question.mode === GAME_MODES.PLAY) {
            questions.push({
                ...commonAssets,
                type: questionType,
                bank: hasBank ? {
                    title: (questionType === TYPE_QUESTIONS.Selection) ? question.ENUNCIADO : null,
                    text: question.DESCRIPCION,
                    source: question.MULTIMEDIA ? `${resources}${question.MULTIMEDIA}` : null,
                    type: question.MULTIMEDIA_TIPO ?? CONTENT_TYPE.TEXT
                } : null
            })
        }
    })
    return questions;
}
